<template>
<v-card>
  <v-overlay v-if="customer.loading" absolute>
    <v-progress-circular indeterminate></v-progress-circular>
    <span style="white-space:nowrap"> Sending email...</span>
  </v-overlay>
  <CardTitle :title="customer.name">
    <template v-slot:prepend_actions>
      <v-tooltip v-if="!customer.dont_send" bottom>
        <template v-slot:activator="{on}">
          <v-btn v-on="on" @click="$emit('update_customer', [customer.id, {dont_send: true}])" color="error" :disabled="preview" small tile outlined class="mr-2"><v-icon>remove</v-icon></v-btn>
        </template>
        <span>Remove from "send all" list</span>
      </v-tooltip>
      <v-tooltip v-else bottom>
        <template v-slot:activator="{on}">
          <v-btn @click="$emit('update_customer', [customer.id, {dont_send: false}])"  small tile outlined class="mr-2"><v-icon>undo</v-icon></v-btn>
        </template>
        <span>undo</span>
      </v-tooltip>
    </template>
    <template v-if="customer.dont_send" v-slot:title>
      <strike>{{customer.name}}</strike>
    </template>
    <template v-slot:actions>
      <v-tooltip bottom>
        <template v-slot:activator="{on:tooltip}">
          <Confirm @confirmed="$emit('delete_email', customer.samples.map(({uuid}) => uuid))">
            <template v-slot:activator="{on:confirm}">
              <v-btn v-on="{...tooltip, ...confirm}" color="error" small tile outlined class="mr-2"><v-icon>delete</v-icon></v-btn>
            </template>
          </Confirm>
        </template>
        <span>Remove from results emails(including all samples from this customer)</span>
      </v-tooltip>
      <v-btn :disabled="customer.dont_send || preview" tile outlined color="success" @click="$emit('send', customer)"><v-icon>mdi-send</v-icon></v-btn>
    </template>
  </CardTitle>
  <v-card-text v-if="!customer.dont_send">
    <v-expansion-panels tile accordion flat multiple>
      <EmailBuilder :key="'email_build_'+customer.name.replaceAll(' ', '_')+ '_' + customer.id" :samples="customer.samples" :customer_id="customer.id" :customer_name="customer.name" @update_customer="$emit('update_customer', $event)"></EmailBuilder>
      <v-divider></v-divider>
      <v-expansion-panel >
        <v-expansion-panel-header>
          <v-list-item class="pa-0">
            <div>Samples to send:  {{customer.samples.filter(sample => !sample.dont_send).length}}
            </div>
            <v-spacer></v-spacer>
            <div>({{customer.samples.filter(sample => sample.dont_send).length}} - removed)</div>
            <v-spacer></v-spacer>
          </v-list-item>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-simple-table>
              <tbody>
                <tr v-for="sample in customer.samples" :key="sample.uuid">
                  <td>
                    <template v-if="!sample.dont_send">
                      {{sample.id}}
                    </template>
                    <strike v-else>{{sample.id}}</strike>
                  </td>
                  <td>{{sample.lot}}</td>
                  <td class="text-right">
                    <v-btn v-if="customer.samples.length === 1" @click="$emit('update_customer', [customer.id, {dont_send: true}])" :disabled="preview" small tile outlined color="error">
                      <v-icon>remove</v-icon>
                    </v-btn>
                    <template v-else>
                      <v-btn v-if="sample.dont_send" @click="restoreSample(sample.uuid)" :disabled="preview" small tile outlined><v-icon>undo</v-icon></v-btn>
                      <v-btn v-else  @click="removeSample(sample.uuid)" :disabled="preview" small tile outlined color="error"><v-icon>remove</v-icon></v-btn>
                    </template>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card-text>
</v-card>
</template>

<script>
export default {
    name: "EmailForm",
    components: {
      EmailBuilder: () => import('./EmailBuilder')
    },
    props:{
      customer: {
        required: true,
      },
      preview: {
        type: Boolean,
        default: false,
      }
    },
    data: () => ({}),
    methods: {
      removeSample(sample_uuid){
        this.$emit("update_sample", [sample_uuid, {dont_send: true,}])
      },
      restoreSample(sample_uuid){
        this.$emit("update_sample", [sample_uuid, {dont_send: false,}])
      }
    }
}
</script>

<style scoped>

</style>
